module.exports = __webpack_public_path__ + "static/media/hurry.62edad7b.png";